var App = App || {};

App.ComponentPartners = (function ($) {
    'use strict';

    function Carousel() {
        $(".component-partners").each(function () {
            const carousel = $(this).find(".splide");

            var splide = new Splide(carousel[0], {
                type: 'loop',
                speed: 500,
                arrows: true,
                pagination: true,
                perPage: 5,
                perMove: 1,
                gap: "3rem",
                breakpoints: {
                    991: {
                        perPage: 5,
                    },
                    768: {
                        perPage: 5,
                        gap: "2rem"
                    },
                    576: {
                        perPage: 1,
                        pagination: false,
                    }
                }
            });

            splide.mount({});
        });
    }

    return {
        Carousel: Carousel
    };

})(jQuery);

$(function () {
    App.ComponentPartners.Carousel();
});